import styled from "styled-components";
import { WalletTab } from "../../../hooks/use-wallet-tab";

export const WalletPageTabWrapper = styled.div<{ activeTab: WalletTab }>`
  display: flex;
  width: 100%;
  position: relative;
  border-bottom: 1px solid #dedede;

  > .background {
    position: absolute;
    top: 0;
    left: ${({ activeTab }) => (activeTab === WalletTab.WALLET ? "0%" : "50%")};
    width: 50%;
    height: 30px;
    z-index: 0;
    transition: left 0.5s ease;
    border-bottom: 1px solid #000000;
  }
`;

export const WalletPageTabItem = styled.div<{ isSelected: boolean }>`
  flex: 1;
  padding-bottom: 10px;
  font-weight: 700;
  font-size: 16px;
  text-align: center;
  color: ${(p) => (p.isSelected ? "#000000" : "#E2E2E2")};
  transition: all 0.4s ease;
`;
